"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SnackbarService = _interopRequireDefault(require("./SnackbarService.js"));

var _notistack = require("notistack");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * HOC to wrap a component with Notistack's `withSnackbar()` 
 * and provide `snack` as a reference to `SnackbarService.snack()`
 */
const withSnackbars = Component => (0, _notistack.withSnackbar)(props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, { ...props,
    snack: _SnackbarService.default.snack
  });
});

var _default = withSnackbars;
exports.default = _default;